(function() {
  // Add custom code below this line

  const BP = 1200;
  const CLS = 'js__show__mobile';

  function forceMobileHeader() {
    const wrapper = document.querySelector('[data-header-wrapper]');
    if (!wrapper) return;

    const shouldBeMobile = document.body.clientWidth < BP;
    wrapper.classList.toggle(CLS, shouldBeMobile);
  }

  function init() {
    forceMobileHeader();

    const wrapper = document.querySelector('[data-header-wrapper]');
    if (!wrapper) return;

    // If the theme tries to override the class, force it back.
    const mo = new MutationObserver(() => {
      const shouldBeMobile = document.body.clientWidth < BP;
      const hasClass = wrapper.classList.contains(CLS);
      if (shouldBeMobile !== hasClass) {
        wrapper.classList.toggle(CLS, shouldBeMobile);
      }
    });

    mo.observe(wrapper, { attributes: true, attributeFilter: ['class'] });

    window.addEventListener('resize', forceMobileHeader);
    window.addEventListener('orientationchange', forceMobileHeader);
    document.addEventListener('shopify:section:load', forceMobileHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();